import { render, staticRenderFns } from "./PagoTooltip.vue?vue&type=template&id=62fe5836&"
import script from "./PagoTooltip.vue?vue&type=script&lang=js&"
export * from "./PagoTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports